import React, { useEffect, useState } from 'react';
import PageLayout from 'components/layouts/PageLayout';
import { Container as MapDiv, NaverMap, Marker, useNavermaps } from 'react-naver-maps';
import { useStateContext } from 'providers/usePageState';
import { toast } from 'react-toastify';
import { Button, Row, Select, useModelStateContext } from 'saladsoft-primitive';
import ServiceHelper from 'stores/ServiceHelper';
import { InnerGroup } from 'components/layouts/CommonForm';
import { InnerSection } from 'components/layouts/CommonForm';
import Text from 'components/commons/Text';
import LocalizeInput from 'components/input/LocalizeInput';
import ButtonWrapper from 'components/pages/listings/ButtonWrapper';
import styled from 'styled-components';
import DaumPostcodeEmbed from 'react-daum-postcode';
import { useStoreWrapper } from 'stores/StoreHelper';
import { AdminListingDto } from 'services/data-contracts';
import { translateText } from 'libs/helper/translationHelper';
import { saveListing } from 'controllers/listingsController';

const LocationPage = () => {
  const navermaps = useNavermaps();

  const { listing, setListing } = useStateContext();
  const { uiStore } = useStoreWrapper();

  const { stateModel, setMultipleState, setState, updateServiceModelMultiple, serviceModel } =
    useModelStateContext<AdminListingDto>();
  const [regions, setRegions] = useState<Array<{ key: string; value: string }>>([]);
  // const [location, setLocation] = useState<{ longitude: number; latitude: number } | null>(null);
  const [mapKey, setMapKey] = useState(0);

  const handleClickFindAddress = () => {
    uiStore?.modal.show({
      title: '주소찾기',
      style: { width: 500, maxHeight: '80%', height: 'auto' },
      children: <DaumPostcodeEmbed style={{ height: '500px' }} onComplete={onCompletePost} />,
    });
  };

  const handleClickTranslateAddress = async () => {
    if (stateModel?.localizedAddress?.ko) {
      const jp = await translateText(stateModel?.localizedAddress?.ko as string, 'ja');
      const zh = await translateText(stateModel?.localizedAddress?.ko as string, 'zh');
      setState('localizedAddress', {
        ...stateModel?.localizedAddress,
        ja: jp as string,
        zh: zh as string,
      });
    } else {
      toast.warning('한글 주소를 입력해주세요.');
    }
  };

  const handleSave = async () => {
    if (serviceModel.current) {
      const newListing = (await saveListing(serviceModel.current)) as AdminListingDto;
      setListing(newListing);
    }
  };

  const onCompletePost = async (post: any) => {
    const jp = await translateText(post.address, 'ja');
    const zh = await translateText(post.address, 'zh');
    setState('localizedAddress', {
      ko: post.address,
      en: post.addressEnglish,
      ja: jp as string,
      zh: zh as string,
    });

    if (post.address) {
      getGeolocation(post.address);
    }
    uiStore?.modal.close();
  };

  const getGeolocation = async (address: string) => {
    navermaps.Service.geocode(
      {
        address: address,
      },
      function (status: any, response: any) {
        if (status !== navermaps.Service.Status.OK) {
          toast.error('지도 취득에 실패했습니다.');
          return;
        }
        const items = response.result.items; // Array of the search result
        setMultipleState({
          latitude: items[0].point.y,
          longitude: items[0].point.x,
        });
        setMapKey((prev) => prev + 1);
      },
    );
  };

  useEffect(() => {
    if (listing?.localizedAddress?.ko) {
      navermaps.Service.geocode(
        {
          address: listing?.localizedAddress.ko,
        },
        function (status: any, response: any) {
          if (status !== navermaps.Service.Status.OK) {
            toast.error('지도 취득에 실패했습니다.');
            return;
          }
          const items = response.result.items; // Array of the search result
          // setLocation({
          //   longitude: items[0].point.x,
          //   latitude: items[0].point.y,
          // });
        },
      );
    }
  }, [listing]);

  useEffect(() => {
    if (listing) {
      setMultipleState(listing);
      setState('localizedAddress', listing.localizedAddress);
      ServiceHelper.adminRegionService?.getRegions1().then((res) => {
        setRegions(
          res.data.map((item) => ({
            key: String(item.id),
            value: item.localizedName?.ko || '',
          })),
        );
      });
    }
  }, [listing]);

  return (
    <PageLayout title="위치">
      {listing && (
        <>
          <InnerSection style={{ minHeight: 'unset' }}>
            <InnerGroup>
              <div>
                <Text type="H3" style={{ marginBottom: 10 }}>
                  지역 선택
                </Text>
                <Text type="H4" buttonRole="DESCRIPTION">
                  시설의 지역을 선택해주세요.
                  <br />
                  지역은 검색 필터링에 사용됩니다.
                </Text>
              </div>
              {listing && regions && (
                <Select
                  placeHolder="지역을 선택 해주세요"
                  defaultKey={listing.region?.id?.toString()}
                  items={regions}
                  onChange={(value) => {
                    setState('region', { id: Number(value.key) });
                  }}
                />
              )}
            </InnerGroup>
          </InnerSection>

          <InnerSection style={{ minHeight: 'unset' }}>
            <InnerGroup>
              <div>
                <Text type="H3" style={{ marginBottom: 10 }}>
                  주소 등록
                </Text>
                <Text type="H4" buttonRole="DESCRIPTION">
                  시설의 주소를 입력하여 주세요.
                  <br />
                  아래의 버튼으로 주소검색이 가능합니다.
                  <br />
                  <span style={{ color: 'var(--point-color)', paddingTop: 10 }}>
                    *영어외의 언어는 구글번역을 이용합니다.
                  </span>
                </Text>
                <Row width="100%" justifyContent="flex-start" gap={10}>
                  <Button
                    type="outlined"
                    onClick={handleClickFindAddress}
                    style={{ marginTop: '20px', width: 150 }}
                  >
                    주소검색
                  </Button>
                  <Button
                    type="outlined"
                    onClick={handleClickTranslateAddress}
                    style={{ marginTop: '20px', width: 200 }}
                  >
                    주소번역(한글/영문이외)
                  </Button>
                </Row>
              </div>
              <div>
                <LocalizeInput
                  value={stateModel?.localizedAddress || {}}
                  onChange={(value) => setState('localizedAddress', value)}
                />
              </div>
            </InnerGroup>
          </InnerSection>
          <InnerSection>
            <InnerGroup>
              <div>
                <Text type="H3" style={{ marginBottom: 10 }}>
                  지도
                </Text>
                <Text type="H4" buttonRole="DESCRIPTION">
                  <span style={{ paddingBottom: 5 }}>한국어 주소 기준으로 표시됩니다.</span>
                  <br />
                  좌표정보가 없는경우 지도가 표시되지 않습니다. 아래 버튼을 눌러 <br />
                  지도를 바인딩 해주세요.
                </Text>
                <Button
                  type="outlined"
                  onClick={() => {
                    getGeolocation(stateModel?.localizedAddress?.ko as string);
                  }}
                  style={{ marginTop: '20px', width: 150 }}
                >
                  지도매핑
                </Button>
              </div>
              {(stateModel?.latitude as number) > 0 && (stateModel?.longitude as number) > 0 && (
                <MapWrapper>
                  <MapDiv
                    key={mapKey}
                    style={{
                      width: '100%',
                      height: '400px',
                    }}
                  >
                    <NaverMap
                      defaultCenter={
                        new navermaps.LatLng(
                          stateModel?.latitude ? stateModel?.latitude : listing?.latitude,
                          stateModel?.longitude ? stateModel?.longitude : listing?.longitude,
                        )
                      }
                      defaultZoom={19}
                    >
                      <Marker
                        defaultPosition={
                          new navermaps.LatLng(
                            stateModel?.latitude ? stateModel?.latitude : listing?.latitude,
                            stateModel?.longitude ? stateModel?.longitude : listing?.longitude,
                          )
                        }
                      />
                    </NaverMap>
                  </MapDiv>
                </MapWrapper>
              )}
            </InnerGroup>
          </InnerSection>
          <ButtonWrapper>
            <Button style={{ width: 100 }} onClick={handleSave}>
              저장
            </Button>
          </ButtonWrapper>
        </>
      )}
    </PageLayout>
  );
};

const MapWrapper = styled.div`
  width: 100%;
  flex: 1;
  height: 400px;
  margin-top: 20px;
  border-radius: 10px;
  overflow: hidden;
`;
export default LocationPage;
